import { BareModal } from '@cb/apricot-react'
import ProfileForm from '../../profileandreg/ProfileForm'
import { REGISTER } from './constants'
import { adjustModalHeight } from '../../../../utilities/dom'
import { useAnalyticsStudentRegStep1Event } from '../../../../hooks/analyticsHooks'

const ID = 'studentProfileModal'

function StudentProfileModal({ changeStep }) {
  const [open, setOpen] = useState(true)
  const useAnimation = true
  const isStandAlone = typeof changeStep !== 'function'

  useAnalyticsStudentRegStep1Event()

  const adjustHeight = () => adjustModalHeight(`#${ID}`)

  return (
    <BareModal
      modalId={ID}
      open={open}
      openAnimation={useAnimation}
      closeAnimation={useAnimation}
      clickOverlayToClose={!isStandAlone}
      escClose={!isStandAlone}
      shadowRoot
      modalNode
      onClose={() => setOpen(false)}
    >
      {open ? (
        <ProfileForm changeStep={changeStep} nextStep={REGISTER} adjustHeight={adjustHeight} />
      ) : (
        <div className="cb-modal-content">
          <span className="sr-only">modal content</span>
        </div>
      )}
    </BareModal>
  )
}

export default StudentProfileModal
